import Message from '@/Messages/Message';
import ComponentManager from '@/Management/ComponentManager';

export default class PrincipalChangedMessage extends Message {

    public principal: any;
    public principalName: string;

    public constructor(params: any) {
        super(params);

        /* Contains the PrincipalDTO received on changing the principal */
        this.principal = params.principal;

        /* Contains the current principal's name */
        this.principalName = params.principalName;
    }
}

ComponentManager.setMessage('PrincipalChangedMessage', PrincipalChangedMessage, 'RADPresentation.HTMLClient.DefaultViewExtensions');